import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './pages/App';
import reportWebVitals from './reportWebVitals';
import {CssBaseline, ThemeProvider} from "@mui/material";
import theme from "./theme";
import {init_sentry} from "./sentryConfig";
import {getEnvironment} from "./utils/environment";
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import PasswordSetupStep from './pages/PasswordSetup';

const environment = getEnvironment()
console.info('Environment: ' + environment)

if (environment === 'production') {
    console.info('Disable debug and info logging')

    console.log = function () {
    };
    console.debug = function () {
    };
    console.info = function () {
    };
}

init_sentry(environment)

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <ThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline/>
        <BrowserRouter>
            <Routes>
                <Route path='/password-setup' element={<PasswordSetupStep/>}/>
                <Route path='/' element={<App/>}/>
            </Routes>
        </BrowserRouter>
    </ThemeProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.info))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
